import { render, staticRenderFns } from "./limitProduct.vue?vue&type=template&id=239d0ac1&scoped=true&"
import script from "./limitProduct.vue?vue&type=script&lang=js&"
export * from "./limitProduct.vue?vue&type=script&lang=js&"
import style0 from "./limitProduct.vue?vue&type=style&index=0&id=239d0ac1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239d0ac1",
  null
  
)

export default component.exports